function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { startTransition } from 'react';
import { hydrateRoot } from 'react-dom/client';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router-dom';
import { getWindow } from '@shared/services/window';
import { initRouterHistory, appHistory } from '@shared/routerHistory';
import { handleRecoverableHydrationError } from '@shared/handlers/recoverableHydrationError';
import { setHydrationStart, setScriptStart } from '@shared/utils/pltUtils';
import { getRoutes } from './Router';
import App, { initApp } from '@appsource/App';
import '@appsource/styles/styles-LTR.scss';
let didInitRouter = false;
setScriptStart();
function hydrateAppSource() {
    return _hydrateAppSource.apply(this, arguments);
}
function _hydrateAppSource() {
    _hydrateAppSource = _async_to_generator(function*() {
        var _getWindow_disablePriorityWorkaround, _getWindow;
        (_getWindow_disablePriorityWorkaround = (_getWindow = getWindow()).disablePriorityWorkaround) === null || _getWindow_disablePriorityWorkaround === void 0 ? void 0 : _getWindow_disablePriorityWorkaround.call(_getWindow);
        if (!didInitRouter) {
            initRouterHistory({
                appRoutes: getRoutes()
            });
            didInitRouter = true;
        }
        const store = initApp();
        const { siteEnvironment } = store.getState().config;
        const root = document.getElementById('react-view');
        setHydrationStart();
        startTransition(()=>{
            hydrateRoot(root, /*#__PURE__*/ _jsx(HistoryRouter, {
                history: appHistory,
                children: /*#__PURE__*/ _jsx(App, {
                    store: store
                })
            }), {
                onRecoverableError: (error)=>handleRecoverableHydrationError(error, siteEnvironment)
            });
        });
    });
    return _hydrateAppSource.apply(this, arguments);
}
window.HYDRATE = hydrateAppSource;
if (window.LOADED) {
    hydrateAppSource();
}
